import React from 'react';
import { Helmet } from 'react-helmet';
import {
  SITE_NAME,
  DEFAULT_TITLE,
  DEFAULT_DESCRIPTION,
  absoluteUrl,
  buildLocalBusinessSchema,
} from '../../seo/siteSeo';

export default function SeoHead({
  title,
  description,
  path = '/',
  type = 'website',
  jsonLd,
  includeLocalBusiness = false,
}) {
  const pageTitle = title || DEFAULT_TITLE;
  const pageDescription = description || DEFAULT_DESCRIPTION;
  const canonical = absoluteUrl(path);
  const schemas = [];

  if (includeLocalBusiness) {
    schemas.push(buildLocalBusinessSchema());
  }
  if (jsonLd) {
    schemas.push(jsonLd);
  }

  return (
    <Helmet>
      <html lang="de" />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={canonical} />

      <meta property="og:locale" content="de_CH" />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={absoluteUrl('/sportplatzgarage.svg')} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={absoluteUrl('/sportplatzgarage.svg')} />

      <meta
        name="keywords"
        content="Sportplatzgarage Davos, stop+go Davos, Audi Garage Davos, VW Garage Davos, Škoda Garage Davos, SEAT Garage Davos, CUPRA Service Davos, Autowerkstatt Davos, Zahnriemen Audi Davos"
      />

      {schemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
